import * as React from 'react';

export interface IProps {}

const Invoices: React.SFC<IProps> = () => <h2>Invoices</h2>;

export default Invoices;
